// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation, // 1. Import useLocation
} from "react-router-dom";
import ReactGA from "react-ga4"; // 2. Import GA4

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Listings from "./pages/Listings";
import Agents from "./pages/Agents";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Sell from "./pages/Sell";

// 3. Initialize Google Analytics with your specific ID
ReactGA.initialize("G-XED6VP8QYL");

// 4. Create a helper component to track page views
// This component listens to the URL and sends updates to Google
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    // Send pageview with the current path (e.g., "/listings")
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null; // It renders nothing, just does the tracking logic
}

function App() {
  return (
    <Router>
      {/* 5. Place the tracker INSIDE the Router */}
      <PageTracker />
      
      <div className="app-root">
        <Navbar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/sell" element={<Sell />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;